<template>
    <div id="healthy_ai">
    <div id="ai_box">
        <div :is="aiView"></div>
    </div>
    </div>    
</template>

<script>
import Chatbot from "../../components/ai/Chatbot.vue";
export default {
  components: {
    Chatbot
  },
  data() {
    return {
      aiView: "Chatbot", 
    }
  }
}
</script>

<style scoped>


#ai_box {
  width: 100%;
  min-height: 700px;
  margin-top: 6px;
  margin-right: 50px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

#healthy_ai {
  text-align: left;
  min-width: 350px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
</style>